import "./TableComponent.css"

const CustomTable = ({children, className, ...props}) => {
  return <div className="overflow-x-auto">
    <table className={`custom-table text-rand-100${className ? ` ${className}`:''}`} {...props}>
      {children}
    </table>
  </div>

}

export const TableRow = ({children, isExpanded = false, expandedChildren, ...props}) => {
  return <tr {...props}>{children}</tr>
  // return <>
  //   <tr>
  //     {children}
  //   </tr>
  //   {isExpanded && <tr>
  //     {expandedChildren}
  //   </tr>}
  // </>
}

export const TableHeader = ({children, className}) => {
  return <th className={`${className ? `${className} ` : ''}text-rand-100 align-middle px-4 py-3 text-xs whitespace-nowrap font-bold text-left`}>
    {children}
  </th>
}

export const TableCell = ({children, className, isActive = true}) => {
  return <td className={`${className ? `${className} ` : ''}custom-table-cell bg-secondary-100`}>
    {isActive ? children :
      <div className={`${isActive ? `` : ' filter grayscale text-gray-300'}`}>
        {children}
      </div>
    }

  </td>
}


export default CustomTable